import React, { useEffect, useState } from 'react'
import {
  Box,
  Flex,
  Image,
  Table,
  TableContainer,
  Text,
} from '@chakra-ui/react'
import Header from '../components/Header'
import Hero from '../components/Hero'
import video from '../assets/IMG_2191.mp4'
import { Navigate, useParams } from 'react-router-dom'
import { cards } from '../mockedData'
import Features from '../components/Features2'
import FixedBg from '../components/FixedBg'
import Footer from '../components/Footer'
import HowToInstall from '../components/HowToInstall'
import { useTranslation } from 'react-i18next'
import AccordionList from '../components/AccordionList'
import { Helmet } from 'react-helmet'

const Product = () => {
  const { id } = useParams()
  const [showCard, setShowCard] = useState()
  const { t, i18n } = useTranslation('common')
  const decodedId = decodeURIComponent(id)
  const product = cards.find(p => p.title === decodedId)

  // If not found, redirect to 404
  if (!product) {
    return <Navigate to="/404" />
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [id])
  useEffect(() => {
    if (showCard) {
      window.scrollTo({ top: 900, behavior: 'smooth' })
    }
  }, [showCard])
  const scrollToDown = () => {
    window.scrollTo({
      top: 900,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    const foundCard = cards?.find(card => card?.title === id)
    if (foundCard) {
      setShowCard(foundCard)
    }
  }, [id])

  if (!showCard) return null

  return (
    <>
      <Helmet>
        <title>
          {product?.name ? `${product.name} - Erri Fireplaces` : 'Erri Fireplaces'}
        </title>
        <meta
          name="description"
          content={
            product?.description ||
            'Discover premium fireplaces by Erri Fire. Browse our products and find the perfect fireplace for your home.'
          }
        />
        <link
          rel="canonical"
          href={`https://errifire.com/products/${product?.id}`}
        />
        {/* Open Graph / Instagram & Facebook */}
        <meta
          property="og:title"
          content={product?.name ? `${product.name} - Erri Fireplaces` : 'Erri Fireplaces'}
        />
        <meta
          property="og:description"
          content={
            product?.description ||
            'Discover premium fireplaces by Erri Fire. Browse our products and find the perfect fireplace for your home.'
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://errifire.com/products/${product?.id}`} />
        <meta
          property="og:image"
          content={product?.imgUrl || 'https://errifire.com/og-image.jpg'}
        />
      </Helmet>

      <Box position="relative">
        <Box
          as="video"
          objectFit="cover"
          height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
          loop
          width="100%"
          playsInline
          webkitplaysinline={true}
          autoPlay
          src={video}
        />
        <Box
          position="absolute"
          width="100%"
          height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
          bgColor="rgba(255,255,255,.1)"
          top="0"
        >
          <Header t={t} i18n={i18n} />
          <Hero scrollTo={scrollToDown} title={showCard?.title} />
        </Box>
      </Box>
      <Flex
        bgColor="blackAlpha.900"
        py="150px"
        mb={{ base: '100px', md: '150px' }}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
      >
        <Box width={{ base: '100%', md: '50%' }}>
          <Text color="whiteAlpha.700" fontSize={{ base: '5xl', md: '5xl' }} align="center">
            {(() => {
              const title = showCard?.title || ''
              const parts = title.split(' ')
              const hasMatch = parts.includes('180') || parts.includes('210')

              if (hasMatch && parts.length === 3) {
                return (
                  <>
                    {parts[0]} {parts[1]}{' '}
                    <Box as="span" fontSize={{ base: 'xl', md: '2xl' }} color="orange.300">
                      {parts[2]}
                    </Box>
                  </>
                )
              }

              return title
            })()}
          </Text>
          <Image mx={{ base: '0' }} width={{ base: '100%', md: '90%' }} src={showCard?.imgUrl} />
        </Box>
        <Box>
          <TableContainer color="whiteAlpha.700">
            <Box>
              <Text fontSize={{ base: 'md', md: '3xl' }} px={{ base: 4, md: 0 }} mb="15px">
                {t(`techTitles.1`)}
              </Text>
            </Box>
            <Table whiteSpace="normal" colorScheme="white">
              <Box maxW={{ base: '375px', md: 'unset' }} fontSize={{ base: 14, md: 20 }} as="tbody">
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.0')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.0`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.1')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.1`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.2')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.2`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.3')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.3`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.4')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.4`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.5')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.5`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.6')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.6`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.7')} </Box>
                  <Box as="td">{t(`${showCard?.translate}.7`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.8')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.8`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.9')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.9`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                >
                  <Box as="td">{t('technicaltitle.10')}</Box>
                  <Box as="td">{t(`${showCard?.translate}.10`)}</Box>
                </Box>
                <Box
                  as="tr"
                  borderBottomWidth="1px"
                  borderBottomColor="gray.600"
                  px={{ base: '0' }}
                  css={{
                    td: {
                      padding: '7px 16px',
                    },
                  }}
                ></Box>
              </Box>
            </Table>

            <Text
              fontSize={{ base: 'md', md: '3xl' }}
              // mb="10px"
              px={{ base: 4, md: 0 }}
              pb="10px"
              borderBottomWidth="1px"
              mt="70px"
            >
              {t('techTitles.0')}
            </Text>
            <AccordionList t={t} i18n={i18n} showCard={showCard} />
          </TableContainer>
        </Box>
      </Flex>
      <Features t={t} />
      <HowToInstall t={t} />
      <Footer t={t} />
    </>
  )
}

export default Product
